import { Component, OnInit, Inject, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { DialogData } from '@app/shared/models/dialog-data';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FocusMonitor } from '@angular/cdk/a11y';
import { ConfirmationType } from '@app/shared/types';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MousePressDirective } from '@app/shared/directives/mouse-press.directive';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'tc-confirm-dialog',
    imports: [
        CommonModule,
        TranslateModule,
        MousePressDirective,
        MatButtonModule
    ],
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConfirmDialogComponent implements AfterViewInit {

  dialogData: DialogData;
  itemToDelete: string;
  confirmationType = ConfirmationType;

  constructor(
    private translate: TranslateService,
    private focusMonitor: FocusMonitor,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.setup();
  }

  ngAfterViewInit(): void {
    // prevent focus on cancel button
    this.focusMonitor.stopMonitoring(document.getElementById('btnCancel'));
  }

  setup(): void {
    this.dialogData = this.data;
    if (this.data.type === ConfirmationType.Confirm) {
      this.translate.get(this.data.message).subscribe(res => {
        this.itemToDelete = res;
      });
    } else {
      let message = 'GENERAL.ALERT_DELETE';
      if (this.data.message) {
        message = this.data.message;
      }
      this.translate.get(message, { value: `<span class='item'>${this.data.title}</span>` }).subscribe(res => {
        this.itemToDelete = res;
      });
    }
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public confirm(): void {
    this.dialogRef.close(true);
  }
}
